import InternalForm, { useForm, FormInstance, FormProps } from './form'
import Item, { FormItemProps } from './form-item'
import ErrorList, { ErrorListProps } from 'antd/lib/form/ErrorList'
import List, { FormListProps, FormListFieldData } from 'antd/lib/form/FormList'
import { FormProvider } from 'antd/lib/form/context'

type InternalFormType = typeof InternalForm

interface FormInterface extends InternalFormType {
  useForm: typeof useForm
  Item: typeof Item
  List: typeof List
  ErrorList: typeof ErrorList
  Provider: typeof FormProvider
}

const Form = InternalForm as FormInterface
Form.Item = Item
Form.List = List
Form.ErrorList = ErrorList
Form.useForm = useForm
Form.Provider = FormProvider

export { Form }

export type {
  FormInstance,
  FormProps,
  FormItemProps,
  ErrorListProps,
  FormListProps,
  FormListFieldData,
}

export type { Rule, RuleObject, RuleRender } from 'antd/lib/form'
